import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY_FILTER_CS} from '../../brand'

export const useGetEmployeeEditorial = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getEmployeeEditorial = async () => {
        const response = await getEntry({
            stack,
            locale: locale.alias,
            contentTypeUid: 'employee_account_editorial',
            brand: BRAND_KEY_FILTER_CS,
        })
        return response ? response[0] : null
    }

    const query = useQuery(['employee_editorial'], () => getEmployeeEditorial())

    return query
}
